import Descriptor from './Descriptor'

export default class CollectionDescriptor extends Descriptor {
  /**
   * Define how to interact with backend and where to get local data
   * Local data must be set when performing actions.all or actions.one
   * @param {string} name - Resource name
   * @param {object} actions - Actions with backend
   * @param {object} local - Local data provider
   */
  constructor (name, actions, local) {
    super(name)
    if (actions) {
      this.fetch.list = actions.list || this.fetch.list
      this.fetch.one = actions.one || this.fetch.one
      this.update = actions.update || this.update
      this.add = actions.add || this.add
      this.delete = actions.delete || this.delete
    }
    if (local) {
      this.provider.list = local.list || this.provider.list
      this.provider.one = local.one || this.provider.one
    }
  }
}



// WEBPACK FOOTER //
// ./packages/helper/resource/index.js